import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { ErrorType } from 'src/app/enums/enums.enum';
import { CustomErrorHandler } from 'src/app/services/error-handler.service';

@Component({
  selector: 'app-create-session',
  template: `<app-page-wait></app-page-wait>`,
  styles: []
})
export class CreateSessionComponent {
  constructor(
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private errorHandler: CustomErrorHandler
  ) {}
  
  ngOnInit() {
    this.createSession();
  }

  async createSession() {
    try {
      await this.sessionService.createNoLoginSession();
      
      if (this.sessionService.hasExistingSession()) {
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        // Un solo `/` inicial: `//evil.com/x` es protocol-relative y startsWith('/')
        // lo dejaba pasar. `\` se excluye porque el navegador lo trata igual que `/`.
        const safeUrl = /^\/(?!\/)[^\\]*$/.test(returnUrl) ? returnUrl : '/';
        this.router.navigateByUrl(safeUrl);
      } else {
        const error = new Error();
        Object.assign(error, {
          status_code: "S00",
          user_message_title: "Ha ocurrido un error",
          user_message_desc: "No se pudo completar la operación. Por favor, intente nuevamente más tarde.",
          data: {
            retry: "true"
          }
        });
  
        this.errorHandler.reportError(error, ErrorType.SESSION_POST);
      }
    } catch (error) {
      this.errorHandler.reportError(error, ErrorType.SESSION_POST);
    }
  }
}
